/**
 * Uses flags, so enumerations can be combined.
 * ie: StateEnter & StateLeave will notify on both.
 */
export var NotificationType;
(function (NotificationType) {
    /**
     * When a state is entered
     * NOTE: 0x001
     */
    NotificationType[NotificationType["StateEnter"] = 1] = "StateEnter";
    /**
     * When a state is left
     * NOTE: 0x010
     */
    // tslint:disable-next-line:no-bitwise
    NotificationType[NotificationType["StateLeave"] = 2] = "StateLeave";
    /**
     * When a transition occurs
     * NOTE: 0x0100
     */
    // tslint:disable-next-line:no-bitwise
    NotificationType[NotificationType["Transition"] = 4] = "Transition";
    /**
     * Includes state enter/leave/transition.  You need to use the event to determine what has occured.
     * NOTE: 0x0111
     */
    // tslint:disable-next-line:no-bitwise
    NotificationType[NotificationType["All"] = 7] = "All";
})(NotificationType || (NotificationType = {}));
//# sourceMappingURL=NotificationType.js.map